import React, { Component } from 'react';
import classnames from 'classnames';
/** PERSONAL */
import Stem from '../NormalStem';
import Footer from '../Footer';
import { reverseParseTextView } from './createRender';

const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);

        const visible = props.showAnswer ? true : false;

        this.state = {
            visible: visible,
            data: reverseParseTextView(props.obj)
        };
    }

    componentDidMount() {
        this.MQLoad();
    }

    componentDidUpdate(prevProps, prevState) {
        this.MQLoad();

        if (this.props.hasOwnProperty('showAllAnswer') && this.props.showAllAnswer !== prevProps.showAllAnswer) {
            this.setState({ visible: this.props.showAllAnswer });
        }
    }

    MQLoad = () => {
        $('.mathquill-embedded-latex', this.viewer).removeAttr('style').each(function (index, item) {
            MQ.StaticMath(item);
        });
    };

    // 显示答案
    toggleAnswer = (val) => {
        this.setState({ visible: val });
    };

    // 导出题目
    handleExport = () => {
        const { handleExport } = this.props;
        handleExport && handleExport();
    };

    // 获取替换题目列表
    getReplaceQuestion = () => {
        const { getReplaceQuestion } = this.props;
        getReplaceQuestion && getReplaceQuestion();
    };

    // 更换题目
    handleReplace = () => {
        const { handleReplace } = this.props;
        handleReplace && handleReplace();
    };

    render() {
        const { visible, data } = this.state;
        let { stem, answer, answerMap, wrong } = data;
        const { num, canShowAnswer, canExport, canRelpace, handleReplace, exported, showTop5 } = this.props;
        const classname = classnames('question-wrapper', {
            'exported': exported
        });

        let multipleAnswer = (answer)=>{
            let arr = false
            let num = answer[0].split('|').length
            if(num>1){
                arr = []
                answer.forEach((val,i)=>{
                    val.split('|').forEach((val1,i1)=>{
                        arr[i1] = arr[i1]||[]
                        arr[i1].push(val1)
                    })
                })
            }

            return arr
        }
        let isMultipleAnswer = false
        if(multipleAnswer(answer)){
            answer = multipleAnswer(answer)
            isMultipleAnswer = true
        }
        return (
            <div className={classname} ref={(el) => { this.viewer = el }}>
                <div className="question-content">
                    {/* 题目序号 */}
                    <div className="question-order">
                        <p className="math_text"><span>{`${num + 1}.`}</span></p>
                    </div>
                    {/* 题目题干 */}
                    <div className="question-stem">
                        <Stem stem={stem} answerMap={answerMap} />
                    </div>
                </div>
                <div className="question-footer">
                    {/* 题目答案 */}
                    {
                        visible ?
                            <div className="footer-hide">

                                {
                                    !isMultipleAnswer?
                                    <div>
                                        <div className="inline-block"><span>{this.props.errorAnswer?'错误答案：':'正确答案：'}</span></div>
                                        <div className="inline-block">
                                            {
                                                answer.map((item, i) =>
                                                    <span className="answer" key={i}>{item.content}</span>
                                                )
                                            }
                                        </div>
                                    </div>
                                    :
                                        answer.map((item,i)=>

                                            <div>
                                                <div className="inline-block"><span>{this.props.errorAnswer?'错误答案：':'正确答案：'}</span></div>
                                                <div className="inline-block">
                                                    {
                                                        answer.map((item, i) =>
                                                            <span className="answer" key={i}>{item.content}</span>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        )

                                }
                            </div> : null
                    }

                    {/* 题目信息 */}
                    <div className="footer-show">
                        <Footer {...this.props}>
                            {
                                canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={() => this.toggleAnswer(!visible)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }
                            {
                                canExport ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.handleExport}>
                                        {!exported ? '选择' : '取消'}
                                    </button> : null
                            }
                            {
                                canRelpace ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.getReplaceQuestion}>更换此题</button> : null
                            }
                            {
                                handleReplace ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.handleReplace}>选择</button> : null
                            }
                        </Footer>
                        {
                            !!data.wrong ?
                                <div>
                                    <div className="inline-block"><span>错误答案TOP5：</span></div>
                                    {
                                        data.wrong.map((wrong, j) =>
                                            <div className="inline-block" key={j}>
                                                {
                                                    wrong.answer.map((item, i) =>
                                                        <span
                                                            style={{ marginRight: 0 }}
                                                            key={i}>{item.content}{i === wrong.answer.length - 1 ? '' : ','}</span>
                                                    )
                                                }
                                                <span>（{wrong.rate}）{j === data.wrong.length - 1 ? '' : '、'}</span>
                                            </div>
                                        )
                                    }
                                </div> : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/fillin/view.js